"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenu = exports.Toggle = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Box_1 = require("../Box");
var Dropdown_1 = require("../Dropdown");
var Ellipsis_1 = require("../Ellipsis");
var Pane_1 = require("../Pane");
exports.Toggle = (0, styled_components_1.default)(Pane_1.PaneOption).attrs({
    p: 3,
    border: "1px solid",
    borderColor: "background",
    backgroundColor: "background",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  ", "\n"], ["\n  display: block;\n  ", "\n"])), Pane_1.paneShadowMixin);
var ContextMenu = function (_a) {
    var children = _a.children, onOpen = _a.onOpen, onClose = _a.onClose, rest = __rest(_a, ["children", "onOpen", "onClose"]);
    return (react_1.default.createElement(Box_1.Box, __assign({ zIndex: 1 }, rest),
        react_1.default.createElement(Dropdown_1.Dropdown, { onOpen: onOpen, onClose: onClose, placement: "bottom-end", label: react_1.default.createElement(exports.Toggle, null,
                react_1.default.createElement(Ellipsis_1.Ellipsis, null)) }, children)));
};
exports.ContextMenu = ContextMenu;
var templateObject_1;
//# sourceMappingURL=ContextMenu.js.map